import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { IConfig } from 'ngx-mask';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { SweetAlertOptions } from 'sweetalert2';
import { ToastrModule } from 'ngx-toastr';

export let bsConfig: Partial<BsDatepickerConfig> = Object.assign(
  {},
  {
    containerClass: 'theme-red',
    isAnimated: true,
    dateInputFormat: 'YYYY-MM-DD ',
    rangeInputFormat: 'YYYY-MM-DD ',
    maxDate: new Date()
  }
);

export let bsConfigCanPickDateFuture: Partial<BsDatepickerConfig> = Object.assign(
  {},
  {
    containerClass: 'theme-red',
    isAnimated: true,
    dateInputFormat: 'YYYY-MM-DD ',
    rangeInputFormat: 'YYYY-MM-DD '
  }
);

export let bsConfigDayMinusOne: Partial<BsDatepickerConfig> = Object.assign(
  {},
  {
    containerClass: 'theme-red',
    isAnimated: true,
    dateInputFormat: 'YYYY-MM-DD ',
    rangeInputFormat: 'YYYY-MM-DD ',
    maxDate: new Date(Date.now() - 86400000),
  }
);

export let sw2Config: SweetAlertOptions = {
  showCloseButton: true,
  showCancelButton: true,
  confirmButtonColor: '#ff3333',
  confirmButtonText: 'Confirm',
  focusCancel: true,
};

export let mdConfig: ModalOptions = {
  animated: false,
  class: 'modal-xl',
  ignoreBackdropClick: true,
  keyboard: false,
};

export let maskConfig: Partial<IConfig> | (() => Partial<IConfig>) = {
  validation: false,
};

export let toastConfig: ToastrModule = {
  timeOut: 10000,
  positionClass: 'toast-top-right',
  closeButton: true,
  progressBar: true,
};

export let bsConfigCanPickOnlyCurrentOrFuture: Partial<BsDatepickerConfig> = Object.assign(
  {},
  {
    containerClass: 'theme-red',
    isAnimated: true,
    dateInputFormat: 'YYYY-MM-DD',
    minDate: new Date(),
  }
);
